import React from "react";
import parse from "html-react-parser";
import PreviouslyOrderedProductStatus from "../../../../../Components/Products/PreviouslyOrderedProductStatus";

const TableTdArticleNumber = (
    {
        td,
        previouslyOrderedProductStatus,
        loadingPreviouslyOrderedProducts,
    }
) => {
    const keys = Object.keys(td);
    const title = (td?.title) ? parse(td?.title) : '';
    const width = keys.includes('width') ? td['width'] : '';
    const col = keys.includes('col') ? td['col'] : '1';

    return (
        <td scope="col"
            width={width}
            colSpan={col}
            className={td['class']}
        >
            {title}
            <PreviouslyOrderedProductStatus loading={loadingPreviouslyOrderedProducts}
                                            status={previouslyOrderedProductStatus}/>
        </td>
    )
}

export default TableTdArticleNumber;
